import { CHAT_OPENING_LINES } from '../../application/consts/chat-opening-lines';

export const getRandomChatOpening = (): string => {
  const array = CHAT_OPENING_LINES;
  const randomIndex = Math.floor(Math.random() * array.length);

  return array[randomIndex];
};
